const codeNumberFormatter = (value) => value.replace(/\D/g, '');

export default codeNumberFormatter;
